import { isPlatformBrowser } from '@angular/common';
import {
  AfterViewInit,
  ChangeDetectorRef,
  Component,
  EventEmitter,
  Inject,
  Input,
  OnDestroy,
  OnInit,
  Output,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { MatDrawer, MatDrawerContent } from '@angular/material/sidenav';
import { environment } from '../../../../environments/environment';
import { ScreenSizeService } from '@/shared/services';
import { Subscription } from 'rxjs';
import { BaseTrackingComponent } from '../base-tracking/base-tracking.component';

@Component({
  selector: 'tool-drawer-container',
  templateUrl: './tool-drawer-container.component.html',
  styleUrl: './tool-drawer-container.component.css',
  standalone: false,
})
export class ToolDrawerContainerComponent
  extends BaseTrackingComponent
  implements OnInit, AfterViewInit, OnDestroy
{
  @Input() shouldShowToggleBtn: boolean = true;
  @Input() toolHeaderWidthPct: string = '100';
  @Output() openFormDialog = new EventEmitter();

  public env = environment;
  public filterState = 'open';
  public innerScreenWidth!: number;
  public isMobileView: boolean = false;
  private subscription = new Subscription();
  public screenSize!: number;
  private onScrollBound!: (event: Event) => void;

  @ViewChild('drawer') drawer!: MatDrawer;
  @ViewChild('drawerContent') drawerContent!: MatDrawerContent;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private _cd: ChangeDetectorRef,
    private screenSizeService: ScreenSizeService,
  ) {
    super();
  }

  ngAfterViewInit() {
    this.addScrollEventOnDrawerContent();
    this.hideDrawer();
  }

  ngOnInit(): void {
    // Maybe hide the scrollbar on the filter
    // if (isPlatformBrowser(this.platformId)) {
    //   const targetDiv = document.getElementsByClassName(
    //     'mat-drawer-inner-container'
    //   )[0];
    //   targetDiv.setAttribute('style', 'overflow:hidden !important');
    // }

    this.subscription.add(
      this.screenSizeService.screenView$.subscribe((view) => {
        if (view === 'mobile') {
          this.isMobileView = true;
          this.hideDrawer();
        } else {
          this.isMobileView = false;
          this.showDrawer();
        }
      }),
    );
  }

  ngOnDestroy(): void {
    this.intervalId && clearInterval(this.intervalId);
    this.trackingService.trackActions();
    this.subscription.unsubscribe();

    if (this.drawerContent) {
      this.drawerContent
        .getElementRef()
        .nativeElement.removeEventListener('scroll', this.onScrollBound);
    }
  }

  hideDrawer() {
    if ((!this.shouldShowToggleBtn || this.isMobileView) && this.drawer) {
      this.drawer.close();
      this._cd.detectChanges(); // Avoid after change detection error
    }
  }

  showDrawer() {
    if (!this.shouldShowToggleBtn) return;

    if (!this.isMobileView && this.drawer) {
      this.drawer.open();
      this._cd.detectChanges(); // Avoid after change detection error
    }
  }

  getFormWidthAndHeight() {
    if (isPlatformBrowser(this.platformId)) {
      // 113 is number of pixels for nav and 63 and number of pixels for footer
      return `width: 100%; height: ${window.innerHeight - 113 - 63}px;`;
    }
    return '100px';
  }

  toggleMatDrawer(drawer: MatDrawer) {
    if (this.isMobileView) {
      this.openFormDialog.emit();
    } else {
      drawer.toggle().then((state) => {
        this.filterState = state;
        const contentWidth =
          this.drawerContent.getElementRef().nativeElement.offsetWidth;
        this.screenSizeService.setContentSize(contentWidth);
        this.screenSizeService.setDrawerState(state);
      });
    }
  }

  addScrollEventOnDrawerContent() {
    this.onScrollBound = this.onContainerScroll.bind(this);

    if (this.drawerContent) {
      this.drawerContent
        .getElementRef()
        .nativeElement.addEventListener('scroll', this.onScrollBound);
    }
  }
}
